module.exports = __webpack_public_path__ + "static/img/background.302d7e9f.svg";